import React from 'react';

const TermsPage: React.FC = () => {
  return (
    <div className="min-h-screen mt-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-8 lg:px-10 pt-8 sm:pt-12 pb-16">
        <header className="mb-8">
          <p className="text-xs font-semibold tracking-[0.16em] text-green-900/75 uppercase mb-3">
            Legal
          </p>
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight">Terms of Service</h1>
          <p className="mt-3 text-sm text-gray-600">
            Last updated: May 7, 2026
          </p>
        </header>

        <div className="space-y-7 text-gray-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Use of the platform</h2>
            <p>
              MarketDataFYI provides research tools and market data summaries for educational and
              informational use. You are responsible for how you use the information and for your
              own investment decisions.
            </p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">No investment advice</h2>
            <p>
              Content on MarketDataFyi is not financial, tax, legal, or investment advice.
              Nothing on this platform should be interpreted as a recommendation to buy or sell
              any security.
            </p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Accounts and payments</h2>
            <p>
              You are responsible for keeping your login credentials secure. Subscription billing,
              renewals, and cancellations are handled via <b>Stripe</b>, our payment processor, through the checkout and billing experience
              shown at the time of purchase.
            </p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Contact</h2>
            <p>
              Questions about these terms can be sent to{' '}
              <a
                href="mailto:support@marketdatafyi.com"
                className="text-green-700 font-medium underline decoration-green-700/30 underline-offset-2"
              >
                support@marketdatafyi.com
              </a>
              .
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
